import { DialogGeometry, DialogViewport } from './is-dialog-geometry';

export type ISDialogLayout = 'cascade' | 'grid' | 'columns' | 'side-by-side';

/** Funções puras: não leem nem alteram DOM; evitam posições negativas. */
export function workspaceRects(count: number, viewport: DialogViewport, layout: ISDialogLayout): DialogGeometry[] {
  if (count <= 0) return [];
  const w = Math.max(1, Math.floor(viewport.width));
  const h = Math.max(1, Math.floor(viewport.height));
  const gap = 10;
  if (layout === 'cascade') {
    const width = Math.min(w, Math.max(360, Math.floor(w * .68)));
    const height = Math.min(h, Math.max(240, Math.floor(h * .70)));
    const maxX = Math.max(0, w - width);
    const maxY = Math.max(0, h - height);
    return Array.from({ length: count }, (_, i) => ({
      x: maxX ? (i * 32) % (maxX + 1) : 0,
      y: maxY ? (i * 28) % (maxY + 1) : 0,
      width, height
    }));
  }
  const columns = layout === 'side-by-side' ? Math.min(2, count)
    : layout === 'columns' ? Math.min(3, count) : Math.ceil(Math.sqrt(count));
  const rows = Math.ceil(count / columns);
  const cellW = w / columns;
  const cellH = h / rows;
  return Array.from({ length: count }, (_, i) => {
    const col = i % columns;
    const row = Math.floor(i / columns);
    const left = Math.round(col * cellW);
    const top = Math.round(row * cellH);
    const right = Math.round((col + 1) * cellW);
    const bottom = Math.round((row + 1) * cellH);
    return {
      x: left + (left ? gap / 2 : 0),
      y: top + (top ? gap / 2 : 0),
      width: Math.max(1, right - left - (left ? gap / 2 : 0) - (col < columns - 1 ? gap / 2 : 0)),
      height: Math.max(1, bottom - top - (top ? gap / 2 : 0) - (row < rows - 1 ? gap / 2 : 0))
    };
  });
}
